import { gql } from "@apollo/client";

const PAGE_FIELDS = "id name status defaultFor categoryIds serviceIds blocks version publishedAt updatedAt";

export const GET_SERVICE_PAGE_META = gql`
  query GetServicePageMeta {
    getServicePageMeta { blockTypes optionSources detailsKeys bulletStyles stepStyles highlightStyles mediaAspects icons autoBlocks }
  }
`;

export const GET_SERVICE_PAGES = gql`
  query GetServicePages {
    getServicePages { status message pages { ${PAGE_FIELDS} } }
  }
`;

export const GET_SERVICE_PAGE = gql`
  query GetServicePage($id: ID!) {
    getServicePage(id: $id) { status message page { ${PAGE_FIELDS} } }
  }
`;

const SERVICE_FIELDS = "id name productName categoryName price campaignPrice campaignLabel campaignEndAt ratingAvg ratingCount bookedLast30Days durationMinutes image isPackage selectionCount members";

export const PREVIEW_SERVICE_DETAIL = gql`
  query PreviewServiceDetail($serviceId: ID!, $data: ServicePageInput) {
    previewServiceDetail(serviceId: $serviceId, data: $data) {
      status
      message
      detail {
        pageId pageName matchedBy note
        service { ${SERVICE_FIELDS} }
        blocks {
          id type title subtitle config
          services { ${SERVICE_FIELDS} }
          reviews { id rating text authorName date serviceSummary }
          ratingSummary { avg count distribution }
          trust { completedServices customers ratingAvg ratingCount }
        }
      }
    }
  }
`;

export const GET_REVIEW_CANDIDATES = gql`
  query GetReviewCandidates($serviceIds: [ID], $categoryId: ID, $minRating: Int, $search: String, $limit: Int) {
    getReviewCandidates(serviceIds: $serviceIds, categoryId: $categoryId, minRating: $minRating, search: $search, limit: $limit) {
      status
      message
      reviews { id rating text authorName date serviceSummary }
    }
  }
`;

export const SAVE_SERVICE_PAGE = gql`
  mutation SaveServicePage($data: ServicePageInput!) {
    saveServicePage(data: $data) { status message id }
  }
`;

export const PUBLISH_SERVICE_PAGE = gql`
  mutation PublishServicePage($id: ID!) { publishServicePage(id: $id) { status message id } }
`;

export const ARCHIVE_SERVICE_PAGE = gql`
  mutation ArchiveServicePage($id: ID!) { archiveServicePage(id: $id) { status message id } }
`;

export const DUPLICATE_SERVICE_PAGE = gql`
  mutation DuplicateServicePage($id: ID!, $name: String!) { duplicateServicePage(id: $id, name: $name) { status message id } }
`;

export const DELETE_SERVICE_PAGE = gql`
  mutation DeleteServicePage($id: ID!) { deleteServicePage(id: $id) { status message id } }
`;
